/* eslint-disable react/jsx-filename-extension */
import React, { useContext, useEffect } from 'react';
import CustomScrollbars from 'util/CustomScrollbars';
import { useDispatch, useSelector } from 'react-redux';
import { useTreatments, SplitContext } from '@splitsoftware/splitio-react';
import Navigation from '../../components/Navigation';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import DeviceThermostatIcon from '@mui/icons-material/DeviceThermostat';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { Badge } from '@mui/material';
import { useApprovalsCount } from 'modules/cbre-approvals-widget';
import { getUserAccess } from 'modules/cbre-flow-api-ducks/selectors';
import { Assignment, People } from '@mui/icons-material';
import { getUserStatusCount } from 'modules/cbre-flow-admin-user-role/ducks/actions';
import { getAdminUserStatusCountUrl, getNeedApprovalCount, getSelectedClient } from 'modules/cbre-flow-admin-user-role/ducks/selectors';

const ApprovalBadge = ({ count = 0, disabled }) => (
  <Badge badgeContent={count} className='approval-icon' color="secondary" max={99}>
    <AssignmentTurnedInIcon />
  </Badge>
);

const AdminBadge = ({ count = 0, disabled }) => (
  <Badge badgeContent={count} className='admin-icon' color="secondary" max={99}>
    <AdminPanelSettingsIcon />
  </Badge>
);

const DashboardBadge = ({ count = 0, disabled }) => (
  <Badge badgeContent={count} className='dashboard-icon' color="secondary" max={99}>
    <DashboardIcon />
  </Badge>
);

const LabInstrumentBadge = ({ count = 0, disabled }) => (
  <Badge badgeContent={count} className='lab-instrument-icon' color="secondary" max={99}>
    <DeviceThermostatIcon />
  </Badge>
);

const LabRequestBadge = ({ count = 0, disabled }) => (
  <Badge badgeContent={count} className='lab-request-icon' color="secondary" max={99}>
    <Assignment />
  </Badge>
);

const EntitlementReviewBadge = ({ count = 0, disabled }) => (
  <Badge badgeContent={count} className='entitlement-review-icon' color="secondary" max={99}>
    <WorkHistoryIcon />
  </Badge>
);

const AdminRoleUserBadge = ({ count = 0, disabled }) => (
  <Badge badgeContent={count} className='entitlement-review-icon' color="secondary" max={99}>
    <People />
  </Badge>
);
// eslint-disable-next-line complexity
const SideBarContent = () => {
  const { isAccountAdmin, hasElevatedAccessGroup } = useSelector(state => state.auth);
  const statusCountUrl = useSelector(getAdminUserStatusCountUrl);
  const needApprovalCount = useSelector(getNeedApprovalCount);
  const selectedClient = useSelector(getSelectedClient);
  const { hasInstrumentPageAccess, hasWorkRequestPageAccess, role, hasEntitlementReviewerWindowAccess, isSystemAdmin, hasSiteAccess, hasApprovalPageAccess, hasUserAndRolePageAccess, hasEntitlementReviewWindowAccess } = useSelector(getUserAccess)

  // Get approval count only once here
  const url = useSelector((state) => state.config.client.flowApiUrl + 'api');
  const { myApprovalCount } = useApprovalsCount({ url });
  const dispatch = useDispatch();
  useEffect(() => {
    if (statusCountUrl && selectedClient?.clientCode && (isSystemAdmin || hasUserAndRolePageAccess)) {
      dispatch(getUserStatusCount(statusCountUrl + `&clientCode=${selectedClient.clientCode}`));
    }      
  }, [dispatch, statusCountUrl, selectedClient?.clientCode, isSystemAdmin, hasUserAndRolePageAccess]);

  const navigationMenus = [
    /* {
      name: 'sidebar.menu',
      type: 'section',
      children: [ */
    {
      name: 'sidebar.dashboard',
      type: 'item',
      isExternalURL: false,
      disabled: false,
      link: '/elis/dashboard',
      RenderIcon: (props) => <DashboardBadge {...props} />, // stateless
      hasVisibility: true,
    },
    {
      name: 'sidebar.instruments',
      type: 'item',
      link: '/elis/instruments',
      disabled: false,
      RenderIcon: (props) => <LabInstrumentBadge {...props} />, // stateless
      hasVisibility: hasInstrumentPageAccess,
    },
    {
      name: 'sidebar.requests',
      type: 'item',
      link: '/elis/requests',
      disabled: false,
      RenderIcon: (props) => <LabRequestBadge {...props} />, // stateless
      hasVisibility: hasWorkRequestPageAccess,
    },
    {
      name: 'sidebar.approvals',
      type: 'item',
      link: '/elis/approvals',
      disabled: false,
      hasVisibility: hasApprovalPageAccess,
      RenderIcon: (props) => <ApprovalBadge {...props} count={myApprovalCount || 0} />
    },
    // {
    //   name: 'sidebar.administration',
    //   type: 'item',
    //   link: '/administration/user-management',
    //   hasVisibility: isSystemAdmin,
    //   RenderIcon: (props) => <AdminBadge {...props} />, // stateless
    //   isbottom: false,
    // },
    // {
    //   name: 'sidebar.entitlementsreview',
    //   type: 'item',
    //   link: '/elis/windows/entitlements-review',
    //   disabled: false,
    //   hasVisibility: isSystemAdmin,
    //   RenderIcon: (props) => <EntitlementReviewBadge {...props} />
    // },
    // {
    //   name: 'sidebar.entitlementsreviewerwindow',
    //   type: 'item',
    //   link: '/elis/windows/entitlements-reviewer-window',
    //   disabled: false,
    //   hasVisibility: isSystemAdmin,
    //   RenderIcon: (props) => <EntitlementReviewBadge {...props} />
    // },
    {
      name: 'sidebar.adminroleuser',
      type: 'item',
      link: '/admin/users',
      disabled: false,
      hasVisibility: isSystemAdmin || hasUserAndRolePageAccess,
      RenderIcon: (props) => <AdminRoleUserBadge {...props} count={needApprovalCount} />
    }
    ];
  
  const visibleNavigationMenus = navigationMenus.filter(menu => menu.hasVisibility);
  
  
  return (
    <CustomScrollbars className=" scrollbar">
      <Navigation menuItems={visibleNavigationMenus} />
    </CustomScrollbars>
  );
};
export default SideBarContent;
